import React from 'react';

const BasePage = props =>(
    <div className="wrapper" style={{height:'100%'}}>
        { props.children }
    </div>
)

export default BasePage;
